import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { AddTransferTypeFormData } from "../form";

export const TransferTypeNameField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddTransferTypeFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Name of Transfer Type</Typography>
      <TextInput
        className="w-full"
        placeholder="Enter Name of Transfer Type"
        maxLength={128}
        hasError={!!errors.name}
        {...register("name")}
      />
      <Typography variant="small" className="leading-relaxed text-neutral-dark-gray">
        This is what your customers would see at booking
      </Typography>
      <ErrorMessage errors={errors} name="name" />
    </div>
  );
};
